module.exports = __webpack_public_path__ + "static/media/solar-strings.4cf746ce.png";